/* global React, Icon */
const { useState: useStateCalc, useMemo: useMemoCalc } = React;

function Calculator() {
  const [visits, setVisits] = useStateCalc(400);
  const [avgCheck, setAvgCheck] = useStateCalc(1200);
  const [missedPct, setMissedPct] = useStateCalc(25);

  const { saved, recovered, payback } = useMemoCalc(() => {
    const adminHoursSaved = Math.round(visits * 0.08);
    const adminCostSaved = Math.round(adminHoursSaved * 200);
    const missed = Math.round((visits * missedPct) / 100);
    const recoveredVisits = Math.round(missed * 0.6);
    const recoveredRevenue = recoveredVisits * avgCheck;
    const monthly = 3900;
    const payback = Math.max(3, Math.round((monthly / (adminCostSaved + recoveredRevenue)) * 30));
    return {
      saved: adminCostSaved,
      recovered: recoveredRevenue,
      payback,
    };
  }, [visits, avgCheck, missedPct]);

  const t = (k) => window.i18n.t(k);
  // Number formatter reads the active locale on every render so locale swaps re-format immediately.
  const fmt = (n) => n.toLocaleString(window.i18n.numberLocale(window.i18n.getLocale()));

  return (
    <section className="section" id="calculator">
      <div className="container calc-wrap">
        <div className="calc-intro">
          <span className="eyebrow">{t("calc.eyebrow")}</span>
          <h2 style={{ marginTop: 16 }}>{t("calc.h2")}</h2>
          <p>{t("calc.lede")}</p>
          <ul>
            <li>
              <Icon name="check" size={18} stroke={2} /> {t("calc.bullet.1")}
            </li>
            <li>
              <Icon name="check" size={18} stroke={2} /> {t("calc.bullet.2")}
            </li>
            <li>
              <Icon name="check" size={18} stroke={2} /> {t("calc.bullet.3")}
            </li>
          </ul>
        </div>
        <div className="calc-card">
          <div className="slider-row">
            <div className="slider-head">
              <span className="lbl">{t("calc.slider.visits.label")}</span>
              <span className="val">
                {fmt(visits)}
                <span className="unit">{t("calc.slider.visits.unit")}</span>
              </span>
            </div>
            <input
              type="range"
              className="slider"
              min={50}
              max={2000}
              step={10}
              value={visits}
              onChange={(e) => setVisits(+e.target.value)}
              aria-label={t("calc.slider.visits.aria")}
            />
          </div>
          <div className="slider-row">
            <div className="slider-head">
              <span className="lbl">{t("calc.slider.avgCheck.label")}</span>
              <span className="val">
                {fmt(avgCheck)}
                <span className="unit">{t("calc.slider.avgCheck.unit")}</span>
              </span>
            </div>
            <input
              type="range"
              className="slider"
              min={400}
              max={5000}
              step={50}
              value={avgCheck}
              onChange={(e) => setAvgCheck(+e.target.value)}
              aria-label={t("calc.slider.avgCheck.aria")}
            />
          </div>
          <div className="slider-row">
            <div className="slider-head">
              <span className="lbl">{t("calc.slider.missed.label")}</span>
              <span className="val">
                {missedPct}
                <span className="unit">{t("calc.slider.missed.unit")}</span>
              </span>
            </div>
            <input
              type="range"
              className="slider"
              min={5}
              max={50}
              step={1}
              value={missedPct}
              onChange={(e) => setMissedPct(+e.target.value)}
              aria-label={t("calc.slider.missed.aria")}
            />
          </div>
          <div className="calc-results">
            <div className="calc-res">
              <div className="label">{t("calc.result.saved.label")}</div>
              <div className="num" key={saved}>
                <span className="currency">₴</span>
                {fmt(saved)}
              </div>
              <div className="sub">{t("calc.result.saved.sub")}</div>
            </div>
            <div className="calc-res">
              <div className="label">{t("calc.result.recovered.label")}</div>
              <div className="num" key={recovered}>
                <span className="currency">₴</span>
                {fmt(recovered)}
              </div>
              <div className="sub">{t("calc.result.recovered.sub")}</div>
            </div>
          </div>
          <div className="calc-payback">
            <div className="pb-l">
              <div className="pb-icon">
                <Icon name="zap" size={20} />
              </div>
              <div className="pb-txt">
                <div className="t">{t("calc.payback.title")}</div>
                <div className="s">{t("calc.payback.sub")}</div>
              </div>
            </div>
            <div className="pb-num">
              {payback} {t("calc.payback.unit")}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

window.Calculator = Calculator;
